// FoodAmigos keeps its own hosts (and local dev); every other host is the shared
// white-label base, where the brand comes from the session or `?partner=`.
export function isFoodAmigosHost(hostname) {
  const host = (hostname ?? '').toLowerCase();

  return (
    host === 'localhost' ||
    host === '0.0.0.0' ||
    host.startsWith('127.') ||
    host === 'foodamigos.io' ||
    host.endsWith('.foodamigos.io')
  );
}
